// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard {
  padding-left: 280px;
  min-height: 100vh;
}

.main-content {
  padding: 2rem;
  background-color: #f8f9fa;
  width: 100%;
  box-sizing: border-box;
}

.point-content {
  background: white;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  width: 100%;
}

.point-content h2 {
  color: #333;
  margin-bottom: 1.5rem;
  font-size: 1.75rem;
}

.info-box {
  background-color: #e3f2fd;
  color: #1976d2;
  padding: 1rem;
  border-radius: 6px;
  border-left: 4px solid #1976d2;
}

.analysis-interface {
  margin-top: 2rem;
}

.analysis-form {
  background: #f8f9fa;
  padding: 1.5rem;
  border-radius: 8px;
  margin-bottom: 2rem;
}

.analysis-form textarea {
  width: 100%;
  padding: 1rem;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  font-family: inherit;
  font-size: 1rem;
  margin-bottom: 1rem;
  resize: vertical;
  box-sizing: border-box;
}

.analysis-options {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.analysis-options label {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 500;
}

.analysis-options input[type="checkbox"] {
  margin: 0;
}

.analysis-options input[type="text"] {
  padding: 0.75rem;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  font-size: 1rem;
  box-sizing: border-box;
}

.analyze-btn {
  background-color: #1976d2;
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 6px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
}

.analyze-btn:hover:not(:disabled) {
  background-color: #1565c0;
}

.analyze-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.analysis-result {
  background: white;
  padding: 1.5rem;
  border-radius: 8px;
  border: 1px solid #dee2e6;
}

.analysis-result h3 {
  color: #333;
  margin-bottom: 1rem;
  font-size: 1.25rem;
}

.result-content {
  line-height: 1.6;
  color: #444;
  margin-bottom: 1.5rem;
  white-space: pre-wrap;
}

.sources {
  border-top: 1px solid #dee2e6;
  padding-top: 1rem;
}

.sources h4 {
  color: #555;
  margin-bottom: 0.5rem;
  font-size: 1rem;
}

.sources ul {
  list-style: none;
  padding: 0;
}

.sources li {
  padding: 0.25rem 0;
  color: #666;
  font-size: 0.9rem;
}

.sources li::before {
  content: "• ";
  color: #1976d2;
  margin-right: 0.5rem;
}`, "",{"version":3,"sources":["webpack://./src/components/Dashboard.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,wCAAwC;EACxC,WAAW;AACb;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;EACpB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,oBAAoB;AACtB","sourcesContent":[".dashboard {\n  padding-left: 280px;\n  min-height: 100vh;\n}\n\n.main-content {\n  padding: 2rem;\n  background-color: #f8f9fa;\n  width: 100%;\n  box-sizing: border-box;\n}\n\n.point-content {\n  background: white;\n  padding: 2rem;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  width: 100%;\n}\n\n.point-content h2 {\n  color: #333;\n  margin-bottom: 1.5rem;\n  font-size: 1.75rem;\n}\n\n.info-box {\n  background-color: #e3f2fd;\n  color: #1976d2;\n  padding: 1rem;\n  border-radius: 6px;\n  border-left: 4px solid #1976d2;\n}\n\n.analysis-interface {\n  margin-top: 2rem;\n}\n\n.analysis-form {\n  background: #f8f9fa;\n  padding: 1.5rem;\n  border-radius: 8px;\n  margin-bottom: 2rem;\n}\n\n.analysis-form textarea {\n  width: 100%;\n  padding: 1rem;\n  border: 1px solid #dee2e6;\n  border-radius: 6px;\n  font-family: inherit;\n  font-size: 1rem;\n  margin-bottom: 1rem;\n  resize: vertical;\n  box-sizing: border-box;\n}\n\n.analysis-options {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  margin-bottom: 1.5rem;\n}\n\n.analysis-options label {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-weight: 500;\n}\n\n.analysis-options input[type=\"checkbox\"] {\n  margin: 0;\n}\n\n.analysis-options input[type=\"text\"] {\n  padding: 0.75rem;\n  border: 1px solid #dee2e6;\n  border-radius: 6px;\n  font-size: 1rem;\n  box-sizing: border-box;\n}\n\n.analyze-btn {\n  background-color: #1976d2;\n  color: white;\n  border: none;\n  padding: 0.75rem 1.5rem;\n  border-radius: 6px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background-color 0.2s;\n}\n\n.analyze-btn:hover:not(:disabled) {\n  background-color: #1565c0;\n}\n\n.analyze-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.analysis-result {\n  background: white;\n  padding: 1.5rem;\n  border-radius: 8px;\n  border: 1px solid #dee2e6;\n}\n\n.analysis-result h3 {\n  color: #333;\n  margin-bottom: 1rem;\n  font-size: 1.25rem;\n}\n\n.result-content {\n  line-height: 1.6;\n  color: #444;\n  margin-bottom: 1.5rem;\n  white-space: pre-wrap;\n}\n\n.sources {\n  border-top: 1px solid #dee2e6;\n  padding-top: 1rem;\n}\n\n.sources h4 {\n  color: #555;\n  margin-bottom: 0.5rem;\n  font-size: 1rem;\n}\n\n.sources ul {\n  list-style: none;\n  padding: 0;\n}\n\n.sources li {\n  padding: 0.25rem 0;\n  color: #666;\n  font-size: 0.9rem;\n}\n\n.sources li::before {\n  content: \"• \";\n  color: #1976d2;\n  margin-right: 0.5rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
